import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-navy px-3 py-4 sm:px-6" data-id="element-18" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-19" data-mp="pjg7a5ljxg31">
        <h2 className="text-center font-heading text-[1.15rem] font-bold uppercase text-gold sm:text-[1.9rem]" data-id="element-20" data-mp="avcxsm8avm9h">
          🎁 5 Professional Bonuses Included
        </h2>
        <div className="mt-2 space-y-2" data-id="element-21" data-mp="fs3cb54gi9ss">
          {bonuses.map(bonus => <article key={bonus.number} className="rounded-md border-l-[5px] border-gold bg-white p-2.5 shadow-sm" data-id="element-22" data-mp="1stxa8rzllqe">
              <h3 className="font-body text-[0.72rem] font-extrabold uppercase leading-tight tracking-wide text-navy sm:text-[0.9rem]" data-id="element-23" data-mp="3o24xc8f089xh">
                🎁 Bonus {bonus.number} — {bonus.title}
              </h3>
              <p className="mt-0.5 font-body text-[0.68rem] font-semibold text-clinical sm:text-[0.8rem]" data-id="element-24" data-mp="1m9yu96s58kuw">
                {bonus.subtitle}
              </p>
              <p className="mt-1 text-[0.8rem] leading-[1.35] text-muted sm:text-[0.95rem]" data-id="element-25" data-mp="1r6z2nocgtzp6">
                {bonus.body}
              </p>
              <p className="mt-1 font-body text-[0.68rem] font-bold uppercase tracking-wide text-gold sm:text-[0.8rem]" data-id="element-26" data-mp="3dg4z8xjz44kq">
                {bonus.steps}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}